import React, { Component } from 'react';


export default class AboutMe extends Component{
  render() {
    return (
      <div>
        <h1> About me </h1>
      </div>  
    )
  }
}
